export const PRIMARY_FONT_FAMILY = '\'Roboto\', sans-serif';
export let FontWeight = /*#__PURE__*/function (FontWeight) {
  FontWeight[FontWeight["THIN"] = 100] = "THIN";
  FontWeight[FontWeight["EXTRA_LIGHT"] = 200] = "EXTRA_LIGHT";
  FontWeight[FontWeight["LIGHT"] = 300] = "LIGHT";
  FontWeight[FontWeight["NORMAL"] = 400] = "NORMAL";
  FontWeight[FontWeight["MEDIUM"] = 500] = "MEDIUM";
  FontWeight[FontWeight["SEMI_BOLD"] = 600] = "SEMI_BOLD";
  FontWeight[FontWeight["BOLD"] = 700] = "BOLD";
  FontWeight[FontWeight["EXTRA_BOLD"] = 800] = "EXTRA_BOLD";
  FontWeight[FontWeight["BLACK"] = 900] = "BLACK";
  return FontWeight;
}({});
export let TypographyName = /*#__PURE__*/function (TypographyName) {
  TypographyName["MEGA"] = "MEGA";
  TypographyName["H1"] = "H1";
  TypographyName["H2"] = "H2";
  TypographyName["H3"] = "H3";
  TypographyName["H4"] = "H4";
  TypographyName["BODY"] = "BODY";
  TypographyName["SMALL"] = "SMALL";
  TypographyName["SMALLER"] = "SMALLER";
  return TypographyName;
}({});
const typographySet = {
  MEGA: {
    weight: FontWeight.BOLD,
    variants: {
      mobile: {
        family: PRIMARY_FONT_FAMILY,
        size: '39.81px',
        lineHeight: '47.77px'
      },
      desktop: {
        family: PRIMARY_FONT_FAMILY,
        size: '67.34px',
        lineHeight: '89.76px'
      }
    }
  },
  H1: {
    weight: FontWeight.BOLD,
    variants: {
      mobile: {
        family: PRIMARY_FONT_FAMILY,
        size: '33.18px',
        lineHeight: '39.81px'
      },
      desktop: {
        family: PRIMARY_FONT_FAMILY,
        size: '59.6px',
        lineHeight: '74px'
      }
    }
  },
  H2: {
    weight: FontWeight.BOLD,
    variants: {
      mobile: {
        family: PRIMARY_FONT_FAMILY,
        size: '27.65px',
        lineHeight: '33.18px'
      },
      desktop: {
        family: PRIMARY_FONT_FAMILY,
        size: '37.90px',
        lineHeight: '50.52px'
      }
    }
  },
  H3: {
    weight: FontWeight.BOLD,
    variants: {
      mobile: {
        family: PRIMARY_FONT_FAMILY,
        size: '23.04px',
        lineHeight: '27.65px'
      },
      desktop: {
        family: PRIMARY_FONT_FAMILY,
        size: '28.43px',
        lineHeight: '37.90px'
      }
    }
  },
  H4: {
    weight: FontWeight.BOLD,
    variants: {
      mobile: {
        family: PRIMARY_FONT_FAMILY,
        size: '19.20px',
        lineHeight: '23.04px'
      },
      desktop: {
        family: PRIMARY_FONT_FAMILY,
        size: '21.33px',
        lineHeight: '28.43px'
      }
    }
  },
  BODY: {
    weight: FontWeight.NORMAL,
    variants: {
      mobile: {
        family: PRIMARY_FONT_FAMILY,
        size: '16px',
        lineHeight: '25.6px'
      },
      desktop: {
        family: PRIMARY_FONT_FAMILY,
        size: '16px',
        lineHeight: '25.6px'
      }
    }
  },
  SMALL: {
    weight: FontWeight.NORMAL,
    variants: {
      mobile: {
        family: PRIMARY_FONT_FAMILY,
        size: '13px',
        lineHeight: '16px'
      },
      desktop: {
        family: PRIMARY_FONT_FAMILY,
        size: '14px',
        lineHeight: '16px'
      }
    }
  },
  SMALLER: {
    weight: FontWeight.NORMAL,
    variants: {
      mobile: {
        family: PRIMARY_FONT_FAMILY,
        size: '12px',
        lineHeight: '14px'
      },
      desktop: {
        family: PRIMARY_FONT_FAMILY,
        size: '12px',
        lineHeight: '13.33px'
      }
    }
  }
};
export default typographySet;
//# sourceMappingURL=typography.js.map